module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "drag"
  }, [_c('div', {
    staticClass: "drag_bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "drag_text"
  }, [_vm._v(_vm._s(_vm.confirmWords))]), _vm._v(" "), _c('div', {
    staticClass: "handler handler_bg",
    on: {
      "mousedown": function($event) {
        return _vm.mousedownFn($event)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae55fa24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerificationSlider.vue
// module id = 466
// module chunks = 0